import { ActionService } from 'dashboard-services/services';

export default (() => {

    const ON_CHANGE = "ON_CHANGE_SELECTED_USER_ROLES"
    const onChange = ActionService.makeActionCreator(ON_CHANGE, "value", "name")

    const addRoles = (rolesArray = [], defaultRoles = []) => (dispatch, getState) => {
      let { roles = [], addedRoles = [], removedRoles = [] } = getState().myAccountState.selectedUserState.selectedUserRolesState
      rolesArray.forEach(role => {
        if(roles.findIndex(r => r?.value === role?.value) < 0) {
          roles = roles.add(role)
        }
        if(defaultRoles.findIndex(r => r.egId === role?.value || r.id === role?.value) < 0 && addedRoles.findIndex(r => r?.value === role?.value) < 0) {
          addedRoles = addedRoles.add(role)
        }
        removedRoles = removedRoles.filter(i => i.label !== role.label)
      })

      dispatch(onChange(roles, "roles"))
      dispatch(onChange(addedRoles, "addedRoles"))
      dispatch(onChange(removedRoles, "removedRoles"))
    }

    const removeRole = (role = {}, defaultRoles = []) => (dispatch, getState) => {
      const { roles = [], removedRoles = [], addedRoles = [] } = getState().myAccountState.selectedUserState.selectedUserRolesState

      dispatch(onChange(roles.filter(i => i.label !== role?.label), "roles"))
      dispatch(onChange(addedRoles.filter(i => i.label !== role?.label), "addedRoles"))
      
      if(defaultRoles.find(r => r.egId === role?.value || r.id === role?.value)) {
        dispatch(onChange(removedRoles.add(role), "removedRoles"))
      }
    }

    const CLEAN_CHANGES = 'CLEAN_CHANGES_SELECTED_USER_ROLES'
    const cleanChanges = ActionService.makeActionCreator(CLEAN_CHANGES)

    const CLEAN_ALL = 'CLEAN_ALL_SELECTED_USER_ROLES'
    const cleanAll = ActionService.makeActionCreator(CLEAN_ALL)

    return {
      ON_CHANGE,
      onChange,
      addRoles,
      removeRole,
      cleanChanges,
      CLEAN_CHANGES,
      cleanAll,
      CLEAN_ALL
    }
})()